import { useEffect, useState } from 'react';
import { authRequest } from '../../common/request/authRequest';

export const useFetch = (url, config, deps, callback) => {

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
  
    setIsLoading(true);

    authRequest(url, config)
      .then((data) => {

        setData(data)
        !!callback ? callback(data) : setData(data);
        setIsLoading(false);
      })
      .catch((error) => {

        setIsLoading(false);

      //   if (error && error.status === 401) {
      //     if (error.data.message === 'Google') {
      //       history.push('/vincular', { from: location });
      //     } else {
      //       logOut();
      //     }
      //   } else {

      //     if (error) {
      //       if (error.status === 403) {
      //         history.push(`${basePath}/error403`, { from: location });
      //       } else if (error.status === 404) {
      //         history.push(`${basePath}/error404`, { from: location });
      //       } else if (error.status === 500) {
      //         history.push(`${basePath}/error500`, { from: location });
      //       } else {
      //         notification.error({
      //           message: t('hooks.useFetch.errors.unexpected.message'),
      //           description: t('hooks.useFetch.errors.unexpected.description')
      //         });
      //       }
      //     } else {

      //       notification.error({
      //         message: t('hooks.useFetch.errors.connection.message'),
      //         description: t('hooks.useFetch.errors.connection.description')
      //       });
      //     }
      //   }
       }
      );
  }, [url, ...deps]);

  return {
    data,
    isLoading,
  };
}